<template>
    <transition name="fade">
        <!-- 1. 在遮罩层同时拦截 touchmove 和 wheel 默认事件 -->
        <div v-if="visible" class="modal-mask" @click="handleClose" @touchmove.prevent @wheel.prevent>
            <div class="modal-box" @click.stop>
                <!-- 头部：标题 + 关闭按钮 -->
                <div class="modal-header">
                    <span class="modal-title">{{ title }}</span>
                    <img class="close-btn" @click="handleClose" src="@/assets/imgs/OpeningCeremony/close.png" alt="">
                </div>

                <!-- 2. 内容区：阻止冒泡，保证弹窗内部能正常用滚轮/手势滑动 -->
                <div class="modal-body" @wheel.stop @touchmove.stop>
                    <!-- 规则 -->
                    <div v-if="type === 'rule'" class="rule" v-html="SeeData"></div>
                    <!-- 当前抽奖记录 -->
                    <div v-if="type == 'Record'" class="Record">
                        <!-- 记录列表 -->
                        <div v-loading="RecordLoading" class="record-list">
                            <div v-if="RecordList.length" v-for="item in RecordList" :key="item.logId"
                                class="record-item">
                                <div class="record-main">
                                    <div class="record-number">
                                        <span class="record-number-label">第</span>
                                        <span class="record-number-value">{{ item.drawNo }}</span>
                                        <span class="record-number-label">抽</span>
                                    </div>

                                    <div class="record-time">
                                        <i class="el-icon-time"></i>
                                        {{ formatDrawTime(item.drawTime) }}
                                    </div>
                                </div>

                                <div class="record-result">
                                    <div class="result-item">
                                        <div class="result-icon coin-icon">
                                            <img src="@/assets/imgs/OpeningCeremony/icon.png" alt="">
                                        </div>
                                        <div class="result-info">
                                            <div class="result-label">获得许愿币</div>
                                            <div class="result-value">+{{ getWishCoin(item) }}</div>
                                        </div>
                                    </div>

                                    <div class="result-item">
                                        <div class="result-icon light-icon"
                                            :class="{ active: getDrawResult(item).repeat === false }">
                                            <i :class="getDrawResult(item).repeat === false
                                                ? 'el-icon-success'
                                                : 'el-icon-remove-outline'"></i>
                                        </div>
                                        <div class="result-info">
                                            <div class="result-label">冰块状态</div>
                                            <div class="result-value"
                                                :class="{ success: getDrawResult(item).repeat === false }">
                                                {{ getDrawResult(item).repeat === false ? '本次点亮' : '未点亮' }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="record-grid">
                                    <span>冰块位置：{{ getDrawResult(item).gridIndex + 1 }}</span>
                                    <!-- <span>序号：{{ getDrawResult(item).ordinal }}</span> -->
                                </div>
                            </div>

                            <el-empty v-if="!RecordLoading && !RecordList.length" description="暂无抽奖记录"
                                :image-size="100" />

                            <div v-if="RecordLoading" class="record-loading-text">
                                正在加载抽奖记录...
                            </div>
                        </div>

                        <!-- 分页 -->
                        <div v-if="RecordTotal > RecordPageSize" class="record-pagination">
                            <el-pagination background layout="prev, pager, next" :current-page="RecordPage"
                                :page-size="RecordPageSize" :total="RecordTotal" @current-change="seeRecord" />
                        </div>
                    </div>
                    <!-- S-兑换 -->
                    <div v-if="type == 'S_Exchange'" class="S_Exchange">
                        <div :class="['reward_items', S_Exchange_Index == value.goodsId ? 'selected' : '']"
                            v-for="(value, index) in SeeData.data" :key="value.goodsId" @click="() => {
                                S_Exchange_Index = value.goodsId
                                S_Exchange_Value = value
                            }">
                            <div class="reward_items_img">
                                <img class="prize_img" :src="value.reward.itemImg" alt="">
                                <div class="sex">
                                    <img v-if="value.reward.sex == 1"
                                        src="@/assets/imgs/OpeningCeremony/userSex1.png" />
                                    <img v-else-if="value.reward.sex == 2"
                                        src="@/assets/imgs/OpeningCeremony/userSex2.png" />
                                    <img v-else-if="value.reward.sex == 3"
                                        src="@/assets/imgs/OpeningCeremony/userSex3.png" />
                                    <img v-else src="@/assets/imgs/OpeningCeremony/userSex4.png" />
                                </div>
                            </div>
                            <div class="reward_items_name">{{ value.goodsName }}</div>
                        </div>
                    </div>

                    <!-- S - 查看 -->
                    <div v-if="type == 'S_See'" class="S_See">
                        <div class="reward_items" v-for="value in SeeData" :key="value">
                            <div class="reward_items_img">
                                <img class="prize_img" :src="value.reward.itemImg" alt="">
                                <div class="sex">
                                    <img v-if="value.reward.sex == 1"
                                        src="@/assets/imgs/OpeningCeremony/userSex1.png" />
                                    <img v-else-if="value.reward.sex == 2"
                                        src="@/assets/imgs/OpeningCeremony/userSex2.png" />
                                    <img v-else-if="value.reward.sex == 3"
                                        src="@/assets/imgs/OpeningCeremony/userSex3.png" />
                                    <img v-else src="@/assets/imgs/OpeningCeremony/userSex4.png" />
                                </div>
                            </div>
                            <div class="reward_items_name">{{ value.reward.name }}</div>
                        </div>
                    </div>
                    <!-- 抽奖 -->
                    <div v-if="type == 'Lottery'" :key="drawRound" class="lottery-result" role="status" aria-live="polite">
                        <div class="lottery-summary">本次{{ SeeData.length > 1 ? '十连抽' : '单抽' }}完成，合计获得
                            <strong>{{ totalWishCoin }}</strong> 许愿币
                        </div>
                        <div class="Lottery">
                        <div class="Lottery_items" v-for="(value, index) in SeeData" :key="index"
                            :style="{ animationDelay: (index * 60) + 'ms' }">
                            <div class="reward_items_img">
                                <img class="prize_img" src="@/assets/imgs/OpeningCeremony/icon.png" alt="">
                            </div>
                            <div class="reward_items_name">许愿币
                                <template v-if="value.wishCoin != 0">
                                    X{{ value.wishCoin }}
                                </template>
                            </div>
                        </div>
                        </div>
                    </div>
                    <!-- 询问是否确定抽奖 -->
                    <div v-if="type == 'is-Lottery'" class="is-Lottery">
                        <div class="hit">
                            确定支付吗
                        </div>
                        <div class="hit" v-if="SeeData.lightedGrids.length == 25">
                            "全部奖励已获取"，确认要抽奖吗
                        </div>
                        <div class="hit">
                            本次消耗：{{ SeeData?.LotteryType == 'one' ? 2 : 20 }}白金币
                        </div>
                    </div>
                    <div v-if="type == 'Buqian'" class="is-Lottery">
                        <div class="hit">
                            确定支付吗
                        </div>
                        <div class="hit">
                            本次补签消耗：20白金币
                        </div>
                    </div>
                    <!-- 兑换专区 -->
                    <div v-if="type == 'exchangeSection'" class="exchangeSection">
                        <div class="exchangeSection_tit">
                            您确定要兑换<span>{{ SeeData?.itemName }}</span>吗
                        </div>
                        <div class="exchangeSection_img">
                            <img :src="SeeData.itemImg" alt="">
                        </div>
                        <div class="exchangeSection_hit">
                            本次操作不可逆
                        </div>
                    </div>

                </div>

                <!-- 底部操作按钮 -->
                <div v-if="!modalFooterType.includes(type)" class="modal-footer">
                    <!-- <button class="btn btn-draw" @click="handleDraw">抽奖</button> -->
                    <!-- <button class="btn btn-exchange" @click="handleExchange">兑换</button> -->
                    <button v-if="type == 'S_Exchange'" :disabled="S_Exchange_Index == null"
                        :class="['btn', S_Exchange_Index ? 'btn_S_Exchange' : 'btn_S_Exchange_no']"
                        @click="confirmFun('S_Exchange', S_Exchange_Value)">兑换</button>
                    <p v-if="type == 'S_Exchange'" class="text_S_Exchange">
                        累计数量:( {{ SeeData.sVoucherTotal }} )，剩余数量:( {{ SeeData.sVoucherBalance }} )， 已使用数量:( {{
                            SeeData.sVoucherUsed }} )
                    </p>

                    <div v-if="type == 'Lottery'" class="Lottery" :class="{ 'draw-disabled': drawBusy }" :aria-disabled="drawBusy">
                        <img src="@/assets/imgs/OpeningCeremony/btn_draw_once.png" class="draw-btn"
                            @click="confirmFun('Lottery', 'one')" />
                        <img src="@/assets/imgs/OpeningCeremony/btn_draw_ten.png" class="draw-btn"
                            @click="confirmFun('Lottery', 'ten')" />
                    </div>
                    <p v-if="type == 'Lottery' && drawBusy" class="lottery-action-tip">正在抽奖或展示奖励，请稍候…</p>
                    <div v-if="type == 'exchangeSection'" class="exchangeSection">
                        <button class="btn btn_S_Exchange" @click="confirmFun('exchangeSection', SeeData)">确认</button>
                        <button class="btn" @click="handleClose">取消</button>
                    </div>
                    <div v-if="type == 'is-Lottery'" class="exchangeSection">
                        <button class="btn btn_S_Exchange"
                            :disabled="drawBusy"
                            @click="confirmFun('is-Lottery', SeeData?.LotteryType)">确认</button>
                        <button class="btn" @click="handleClose">取消</button>
                    </div>
                    <div v-if="type == 'Buqian'" class="exchangeSection">
                        <button class="btn btn_S_Exchange" @click="confirmFun('Buqian', SeeData)">确认</button>
                        <button class="btn" @click="handleClose">取消</button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import {
    drawRecordsApi
} from './index'
export default {
    name: 'See',
    props: {
        drawBusy: { type: Boolean, default: false },
        drawRound: { type: Number, default: 0 },
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: '弹窗标题'
        },
        type: {
            type: String,
            default: 'Rules'
        },
        SeeData: {
            type: [Object, Array, Number, String],
            default: () => null
        }
    },
    data() {
        return {
            modalFooterType: ['Lottery, S_Exchange'],
            S_Exchange_Index: null,
            S_Exchange_Value: null,

            RecordList: [],
            RecordTotal: 0,
            RecordPage: 1,
            RecordPageSize: 20,
            RecordLoading: false,
 
    
        }
    },
    computed: {
        totalWishCoin() {
            return Array.isArray(this.SeeData)
                ? this.SeeData.reduce((total, item) => total + (Number(item.wishCoin) || 0), 0)
                : 0
        }
    },
    methods: {
        // 关闭弹窗
        handleClose() {
            if (this.drawBusy) return
            this.$emit('update:visible', false)
            this.$emit('close')
        },

        // ESC 键关闭
        onEscClose(e) {
            if (e.key === 'Escape' && this.visible) {
                this.handleClose()
            }
        },
        // 选择确定通知父组件
        confirmFun(type, data) {
            if (this.drawBusy && (type === 'Lottery' || type === 'is-Lottery')) return
            // console.log(data, this.SeeData);

            this.$emit('confirmFun', {
                type,
                data
            })
        },

        // 获取抽奖记录
        seeRecord(page = 1) {
            this.RecordPage = page
            this.RecordLoading = true

            drawRecordsApi({
                page: page,
                pageSize: this.RecordPageSize,
            }).then((res) => {
                if (res.data.state == 200) {
                    const data = res.data.data || {}

                    this.RecordList = Array.isArray(data.list)
                        ? data.list
                        : []

                    this.RecordTotal = Number(data.total || 0)
                    this.RecordPage = Number(data.page || page)
                    this.RecordPageSize = Number(data.pageSize || 20)
                } else {
                    this.RecordList = []
                    this.RecordTotal = 0
                    this.$message.info(res.data.message || '获取抽奖记录失败')
                }
            }).catch(err => {
                this.RecordList = []
                this.RecordTotal = 0
                this.$message.error(err.message || '获取抽奖记录失败')
            }).finally(() => {
                this.RecordLoading = false
            })
        },

        // 当前记录的抽奖结果
        getDrawResult(item) {
            return item && item.drawResult
                ? item.drawResult
                : {}
        },

        // 获得的许愿币
        getWishCoin(item) {
            const result = this.getDrawResult(item)
            return Number(result.wishCoin || 0)
        },

        // drawTime 是 Unix 时间戳，接口返回的是秒
        formatDrawTime(timestamp) {
            if (!timestamp) {
                return '--'
            }

            const date = new Date(Number(timestamp) * 1000)

            if (isNaN(date.getTime())) {
                return '--'
            }

            const pad = (value) => String(value).padStart(2, '0')

            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
        }
    },
    watch: {
        type(value) {
            if (value === 'Record') {
                this.seeRecord(1)
            }
        },
        visible(value) {
            if (value && this.type === 'Record') {
                this.seeRecord(1)
            }
        }
    },
    mounted() {
        window.addEventListener('keydown', this.onEscClose)

        if (this.type == 'Record') {
            this.seeRecord(1)
        }
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.onEscClose)
    }
}
</script>

<style scoped lang="less">
// 全局变量：统一改主题直接修改变量
@mask-bg: rgba(0, 0, 0, 0.5);
@modal-bg: linear-gradient(180deg,
        #e3f0ff 0%,
        #a8c8ff 48%,
        #5a86d8 100%);
@modal-radius: 20px;
@modal-width: 780px;
@border-color: #f0f0f0;
@text-primary: #222222;
@text-secondary: #999999;
@color-draw: #4080ff;
@color-exchange: #ff7d00;
@modal-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
@transition-base: 0.25s ease;
@textShadow: -1px -1px 0 #0074e1ff, 1px -1px 0 #0074e1ff, -1px 1px 0 #0074e1ff,
    1px 1px 0 #0074e1ff;

/* 遮罩层 */
.modal-mask {
    position: fixed;
    inset: 0;
    background: @mask-bg;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;

    /* 弹窗主体 */
    .modal-box {
        width: @modal-width;
        max-width: 92vw;
        max-height: 85vh;
        background: @modal-bg;
        border-radius: @modal-radius;
        box-shadow: @modal-shadow;
        display: flex;
        flex-direction: column;

        /* 头部 */
        .modal-header {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 18px 24px;
            flex-shrink: 0;
            position: relative;

            .modal-title {
                font-size: 22px;
                font-weight: 700;
                font-family: '思源宋体', 'Noto Serif SC', serif; // 衬线体
                color: #2D2D2D;
                letter-spacing: 6px;
                padding-bottom: 10px;
                position: relative;
                display: inline-block;

                &::after {
                    content: '';
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: 2px;
                    background: linear-gradient(90deg,
                            transparent 0%,
                            #D4A853 20%,
                            #F0D78C 50%,
                            #D4A853 80%,
                            transparent 100%);
                }
            }

            .close-btn {
                position: absolute;
                width: 100px;
                right: -50px;
                top: -45px;
                cursor: pointer;
            }
        }

        /* 内容区 */
        .modal-body {
            flex: 1;
            overflow-y: auto;
            padding: 24px;
            color: @text-primary;

            /* 阻止内部滚动链穿透到外层背景 */
            overscroll-behavior: contain;

            // 滚动条美化
            &::-webkit-scrollbar {
                width: 6px;
            }

            &::-webkit-scrollbar-thumb {
                background: #dcdfe3;
                border-radius: 3px;
            }

            // 奖励列表
            .reward_items {
                width: 180px;
                height: 160px;
                padding: 8px 6px;
                box-sizing: border-box;
                background: linear-gradient(135deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0.08) 100%);
                -webkit-backdrop-filter: blur(8px);
                backdrop-filter: blur(8px);
                border-radius: 14px;
                border: 1px solid rgba(255, 255, 255, 0.4);
                box-shadow: 0 4px 12px rgba(0, 30, 80, 0.15), inset 0 1px 1px rgba(255, 255, 255, 0.5);
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-between;
                overflow: hidden;
                transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

                /* 悬浮动效：微抬 + 亮光 + 边框高亮 */
                &:hover {
                    transform: translateY(-4px) scale(1.02);
                    background: linear-gradient(135deg, rgba(255, 255, 255, 0.38) 0%, rgba(255, 255, 255, 0.15) 100%);
                    border-color: rgba(255, 255, 255, 0.8);
                    box-shadow: 0 8px 20px rgba(0, 100, 220, 0.3), inset 0 0 10px rgba(255, 255, 255, 0.6);

                    .prize_img {
                        transform: scale(1.1);
                    }
                }

                .reward_items_img {
                    width: 100%;
                    height: 80%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: relative;

                    .prize_img {
                        max-width: 80%;
                        filter: drop-shadow(0 4px 6px rgba(0, 20, 50, 0.3));
                        transition: transform 0.3s ease;
                    }

                    .sex {
                        position: absolute;
                        top: 0;
                        left: 0;
                    }
                }

                .reward_items_name {
                    width: 100%;
                    height: 15%;
                    line-height: 1.5em;
                    font-size: 12px;
                    font-weight: 700;
                    text-align: center;
                    text-shadow: 0 1px 3px #1706ff;
                    color: #fff;
                }
            }

            // 规则
            .rule {}

            // 当前奖池预览
            // ==============================
            // 抽奖记录
            // ==============================
            .Record {
                width: 100%;
                min-height: 420px;
                box-sizing: border-box;

                // 记录列表
                .record-list {
                    width: 100%;
                    min-height: 380px;
                    box-sizing: border-box;
                    position: relative;
                }

                // 单条记录
                .record-item {
                    width: 100%;
                    box-sizing: border-box;
                    padding: 18px 22px;
                    margin-bottom: 14px;

                    position: relative;
                    overflow: hidden;

                    border-radius: 16px;

                    background:
                        linear-gradient(135deg,
                            rgba(255, 255, 255, 0.55) 0%,
                            rgba(255, 255, 255, 0.25) 100%);

                    border: 1px solid rgba(255, 255, 255, 0.65);

                    box-shadow:
                        0 5px 15px rgba(38, 91, 170, 0.12),
                        inset 0 1px 2px rgba(255, 255, 255, 0.7);

                    backdrop-filter: blur(10px);
                    -webkit-backdrop-filter: blur(10px);

                    transition:
                        transform 0.25s ease,
                        box-shadow 0.25s ease,
                        background 0.25s ease;

                    // 顶部高光
                    &::before {
                        content: '';
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 100%;
                        height: 2px;

                        background: linear-gradient(90deg,
                                transparent,
                                rgba(255, 255, 255, 0.9),
                                transparent);
                    }

                    // 左侧装饰线
                    &::after {
                        content: '';
                        position: absolute;
                        left: 0;
                        top: 18px;
                        bottom: 18px;
                        width: 3px;

                        border-radius: 0 3px 3px 0;

                        background: linear-gradient(180deg,
                                #74b9ff,
                                #4078d8);
                    }

                    &:hover {
                        transform: translateY(-2px);

                        background:
                            linear-gradient(135deg,
                                rgba(255, 255, 255, 0.68) 0%,
                                rgba(255, 255, 255, 0.32) 100%);

                        box-shadow:
                            0 10px 25px rgba(38, 91, 170, 0.2),
                            inset 0 1px 3px rgba(255, 255, 255, 0.8);
                    }

                    // ==========================
                    // 第一行：抽奖次数 + 时间
                    // ==========================
                    .record-main {
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        padding-bottom: 14px;
                        margin-bottom: 14px;

                        border-bottom: 1px dashed rgba(71, 116, 180, 0.25);

                        .record-number {
                            display: flex;
                            align-items: baseline;
                            gap: 4px;

                            .record-number-label {
                                font-size: 14px;
                                color: #52709c;
                                font-weight: 500;
                            }

                            .record-number-value {
                                font-size: 25px;
                                font-weight: 800;
                                font-style: italic;

                                color: #315fa7;

                                text-shadow:
                                    0 1px 0 rgba(255, 255, 255, 0.9),
                                    0 2px 4px rgba(48, 96, 166, 0.18);
                            }
                        }

                        .record-time {
                            display: flex;
                            align-items: center;

                            font-size: 13px;
                            color: #6f86a7;

                            .el-icon-time {
                                margin-right: 5px;
                                font-size: 15px;
                                color: #638bc5;
                            }
                        }
                    }

                    // ==========================
                    // 第二行：抽奖结果
                    // ==========================
                    .record-result {
                        width: 100%;

                        display: grid;
                        grid-template-columns: 1fr 1fr;
                        gap: 14px;

                        .result-item {
                            min-height: 70px;

                            display: flex;
                            align-items: center;

                            padding: 10px 14px;
                            box-sizing: border-box;

                            border-radius: 12px;

                            background: rgba(255, 255, 255, 0.28);
                            border: 1px solid rgba(255, 255, 255, 0.35);

                            .result-icon {
                                width: 46px;
                                height: 46px;

                                flex-shrink: 0;

                                display: flex;
                                align-items: center;
                                justify-content: center;

                                margin-right: 12px;

                                border-radius: 12px;

                                background: rgba(255, 255, 255, 0.45);

                                box-shadow:
                                    0 3px 8px rgba(35, 75, 130, 0.12),
                                    inset 0 1px 2px rgba(255, 255, 255, 0.7);

                                // 许愿币
                                &.coin-icon {
                                    img {
                                        width: 34px;
                                        height: 34px;
                                        object-fit: contain;

                                        filter:
                                            drop-shadow(0 2px 4px rgba(255, 180, 40, 0.35));
                                    }
                                }

                                // 点亮状态
                                &.light-icon {
                                    color: #a8b5c7;
                                    font-size: 30px;

                                    transition: all 0.25s ease;

                                    &.active {
                                        color: #35c98a;

                                        background: rgba(74, 218, 157, 0.14);

                                        box-shadow:
                                            0 0 12px rgba(53, 201, 138, 0.25),
                                            inset 0 0 8px rgba(255, 255, 255, 0.5);
                                    }
                                }
                            }

                            .result-info {
                                min-width: 0;

                                .result-label {
                                    font-size: 13px;
                                    color: #6680a5;
                                    margin-bottom: 5px;
                                }

                                .result-value {
                                    font-size: 19px;
                                    font-weight: 800;

                                    color: #426ba8;

                                    &.success {
                                        color: #20ad76;

                                        text-shadow:
                                            0 1px 3px rgba(32, 173, 118, 0.2);
                                    }
                                }
                            }
                        }
                    }

                    // ==========================
                    // 第三行：位置 / 序号
                    // ==========================
                    .record-grid {
                        width: 100%;

                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        margin-top: 14px;
                        padding-top: 12px;

                        border-top: 1px dashed rgba(71, 116, 180, 0.18);

                        span {
                            display: inline-flex;
                            align-items: center;

                            padding: 5px 10px;

                            border-radius: 6px;

                            background: rgba(255, 255, 255, 0.25);

                            font-size: 12px;
                            color: #7187a6;
                        }
                    }
                }

                // ==========================
                // 加载文字
                // ==========================
                .record-loading-text {
                    position: absolute;

                    left: 50%;
                    top: 50%;

                    transform: translate(-50%, -50%);

                    color: #5375a6;
                    font-size: 14px;

                    letter-spacing: 1px;
                }

                // ==========================
                // Element Empty
                // ==========================
                .el-empty {
                    padding: 70px 0;

                    ::v-deep .el-empty__description {
                        p {
                            color: #6c82a2;
                            font-size: 14px;
                        }
                    }
                }

                // ==========================
                // 分页
                // ==========================
                .record-pagination {
                    width: 100%;

                    display: flex;
                    align-items: center;
                    justify-content: center;

                    padding-top: 10px;
                    padding-bottom: 4px;

                    ::v-deep .el-pagination {
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        .btn-prev,
                        .btn-next,
                        .number {
                            min-width: 32px;
                            height: 32px;

                            line-height: 32px;

                            padding: 0;

                            border-radius: 8px !important;

                            color: #52719e;

                            background: rgba(255, 255, 255, 0.42);

                            border: 1px solid rgba(255, 255, 255, 0.55);

                            box-shadow:
                                0 2px 6px rgba(45, 85, 140, 0.08);

                            transition: all 0.2s ease;

                            &:hover {
                                color: #fff;

                                background: #6391d2;

                                transform: translateY(-1px);
                            }
                        }

                        .number.active {
                            color: #fff;

                            background: linear-gradient(135deg,
                                    #76a8ed,
                                    #4778c7);

                            border-color: transparent;

                            box-shadow:
                                0 4px 10px rgba(71, 120, 199, 0.28);
                        }

                        .more {
                            color: #6681a7;
                        }
                    }
                }
            }

            // S-兑换
            .S_Exchange {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-around;
                gap: 30px 20px;

                .selected {
                    border: 2px solid #ffd76e;
                    background: rgba(255, 200, 80, 0.12);
                    box-shadow:
                        0 0 20px rgba(255, 190, 60, 0.7),
                        0 0 42px rgba(255, 150, 30, 0.45),
                        inset 0 0 18px rgba(255, 240, 200, 0.5);
                    transform: translateY(-2px) scale(1.03);
                    transition: all 0.22s ease;
                    animation: breathGold 1.8s ease-in-out infinite;
                }

                @keyframes breathGold {

                    0%,
                    100% {
                        box-shadow:
                            0 0 20px rgba(255, 190, 60, 0.7),
                            0 0 42px rgba(255, 150, 30, 0.45),
                            inset 0 0 18px rgba(255, 240, 200, 0.5);
                    }

                    50% {
                        box-shadow:
                            0 0 32px rgba(255, 210, 90, 1),
                            0 0 60px rgba(255, 170, 50, 0.7),
                            inset 0 0 24px rgba(255, 248, 220, 0.7);
                    }
                }
            }

            //S- 查看
            .S_See {
                width: 100%;
                min-height: 300px;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-around;
                gap: 30px 20px;
            }

            .lottery-summary {
                padding: 14px;
                text-align: center;
                color: #23466b;
                font-size: 22px;
                background: linear-gradient(110deg, rgba(220, 247, 255, 0.08), rgba(220, 247, 255, 0.24) 50%, rgba(220, 247, 255, 0.08));
                border: 1px solid rgba(225, 248, 255, 0.32);
                box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2);
                text-shadow: none;
                border-radius: 12px;
                strong { color: #995000; font-size: 30px; font-weight: 700; }
            }
            .lottery-result .Lottery_items {
                animation: lottery-reward-in 450ms ease-out both;
            }
            @keyframes lottery-reward-in {
                from { opacity: 0; transform: translateY(20px) scale(0.8); }
                to { opacity: 1; transform: translateY(0) scale(1); }
            }
            @media (prefers-reduced-motion: reduce) {
                .lottery-result .Lottery_items { animation: none; }
            }
            // 抽奖
            .Lottery {
                width: 100%;
                height: 500px;
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                justify-content: center;
                gap: 14px;

                .Lottery_items {
                    width: 18%;
                    height: 150px;
                    background: linear-gradient(135deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0.08) 100%);
                    border: 1px solid rgba(255, 255, 255, 0.4);
                    box-shadow: 0 4px 12px rgba(0, 30, 80, 0.15), inset 0 1px 1px rgba(255, 255, 255, 0.5);
                    border-radius: 24px;

                    .reward_items_img {
                        height: 75%;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        .prize_img {
                            width: 90%;
                            max-height: 100%;
                        }
                    }

                }

                .reward_items_name {
                    height: 20%;
                    font-size: 1em;
                    text-align: center;
                    color: #fff;
                    text-shadow: @textShadow;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }

            // 询问是非确定抽奖
            .is-Lottery {
                display: flex;
                justify-content: center;
                gap: 30px 0;
                flex-direction: column;
                align-items: center;
                height: 300px;

                .hit {
                    font-size: 20px;
                    font-weight: 700;
                    letter-spacing: 3px;
                    text-shadow: @textShadow;
                    color: #fff;
                }
            }

            // 兑换专区
            .exchangeSection {
                display: flex;
                justify-content: center;
                gap: 30px 0;
                flex-direction: column;
                align-items: center;

                .exchangeSection_tit {
                    font-size: 18px;
                    font-weight: 700;
                    letter-spacing: 3px;

                    span {
                        color: red;
                        font-size: 24px;
                    }
                }

                .exchangeSection_img {
                    width: 50%;

                    >img {
                        width: 100%;
                    }
                }
            }
        }

        /* 底部按钮区 */
        .modal-footer {
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            gap: 12px;
            padding: 16px 24px;
            flex-shrink: 0;

            .btn {
                padding: 8px 40px;
                border: none;
                border-radius: 8px;
                font-size: 18px;
                cursor: pointer;
                transition: all 0.2s;

                &:hover {
                    transform: translateY(-1px);
                    filter: brightness(1.05);
                }
            }

            .btn-draw {
                background: @color-draw;
                color: #fff;
            }

            .btn_S_Exchange {
                background: @color-exchange;
                color: #fff;

            }

            .btn_S_Exchange_no {
                background: #ccc;
                cursor: not-allowed;
                color: #999;
            }

            .text_S_Exchange {
                color: rgb(255, 255, 255);
                font-size: 18px;
                text-shadow: -1px -1px 0 @color-exchange, 1px -1px 0 @color-exchange, -1px 1px 0 @color-exchange, 1px 1px 0 @color-exchange;
                font-family: '思源宋体', 'Noto Serif SC', serif;
                letter-spacing: 3px;
            }

            .Lottery {
                display: flex;
                gap: 50px;
                justify-content: center;

                &.draw-disabled {
                    pointer-events: none;
                    opacity: 0.45;
                    filter: grayscale(1);
                }

                .draw-btn {
                    max-width: 30%;
                }

                .draw-btn:hover {
                    animation-play-state: paused;
                    transform: scale(1.08);
                    filter: drop-shadow(0 0 8px rgba(59, 130, 246, 0.8)) brightness(1.15);
                }
            }

            .exchangeSection {
                display: flex;
                gap: 30px;
            }

            .lottery-action-tip {
                margin-top: 12px;
                text-align: center;
                color: #fff;
                font-size: 16px;
            }

        }
    }
}

/* 淡入淡出动画 */
.fade-enter-active,
.fade-leave-active {
    transition: opacity @transition-base;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
